import {
  HomeIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
} from '@heroicons/react/24/solid';
import { NavLink } from 'react-router';

function MobileNavAuthed() {
  return (
    <>
      <NavLink
        to="/"
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <HomeIcon className="size-6 text-rcprimary-400" aria-hidden="true" />
          <span>Dashboard</span>
        </div>
      </NavLink>
      <NavLink
        to="/shop"
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <ShoppingBagIcon
            className="size-6 text-rcprimary-400"
            aria-hidden="true"
          />
          <span>Shop</span>
        </div>
      </NavLink>
      <NavLink
        to="/my-orders"
        className="group -mx-3 flex w-full items-center justify-between gap-x-2.5 rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-6 hover:bg-gray-200 focus:outline-none"
      >
        <div className="flex items-center gap-x-2.5">
          <ShoppingCartIcon
            className="size-6 text-rcprimary-400"
            aria-hidden="true"
          />
          <span>Orders</span>
        </div>
      </NavLink>
    </>
  );
}

export default MobileNavAuthed;
